import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../../common/breadcrumbs";
import { SWAL_SETTINGS, INPUT_LENGTH_100, INPUT_LENGTH_500, VIDEO_CATEGORY } from "../../../../../../utils/Constants";
import {
    capitalizeFirstLetter,
    globalLoader,
    handleServerValidations,
    validateYouTubeUrl,
} from "../../../../../../utils/commonfunction";
import { Tooltip, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import CustomCkeditor from "../../../../common/customeditor";
import { AddEducationalVideo } from "../../../../services/usermgmt.services";

const EducationalVideoAdd = () => {
    const params = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();
    const { t } = useTranslation()
    const [submitted, setSubmitted] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [previewimage, setPreviewImage] = useState("");
    const [categories, setCategories] = useState([]);

    const breadcrumbs = [
        { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
        {
        title: t("Center Management"),
        url: "/admin/center-management/center/list/1",
        },
        {
        title: t("Videos"),
        url: `/admin/center-management/center/educational-video/${params.center_id}/list/1`,
        },
        { title: t("admin.faq.link_add"), url: "" },
    ];

    // useEffect(() => {
    //     videoServices
    //         .AllCategoryList()
    //         .then((res) => {
    //             setCategories(res.data);
    //         })
    //         .catch((error) => {
    //             console.log("error", error);
    //         });
    // }, []);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {/* {dataLoaded ? ( */}
            <Formik
                initialValues={{
                    title: "",
                    description: "",
                    // category: "",
                    video_type: "",
                    video_length: "",
                    video_link: "",
                    video: "",
                    thumbnail_image: ""
                }}
                validateOnBlur={false}
                validate={(values) => {
                    const error = {};
                    const MAX_VIDEO_SIZE_MB = 10;
                    const MAX_IMAGE_SIZE_MB = 1.5;
                    const allowedTypes = ["video/mp4", "video/webm", "video/ogg", "video/quicktime"];

                    if (!values.title || !values.title.trim()) {
                        error.title = "admin.faq.label_title_error";
                    } else if (values.title.length > INPUT_LENGTH_500) {
                        error.title = "admin.faq.validation_err_reached_maximum_length";
                    }

                    if (!values.description || !values.description.trim()) {
                        error.description = "admin.faq.label_description_error";
                    }

                    // if (!values.category) {
                    //     error.category = "Category is required";
                    // }

                    if (values.thumbnail_image) {
                        const fileSizeMB = values.thumbnail_image.size / (1024 * 1024);
                        if (fileSizeMB > MAX_IMAGE_SIZE_MB) {
                            error.thumbnail_image = `Thumbnail image size should not exceed ${MAX_IMAGE_SIZE_MB}MB.`;
                        }
                    }

                    // if (!values.video) {
                    //     error.video = "Please upload a video.";
                    // } else {
                    //     if (!allowedTypes.includes(values.video.type)) {
                    //         error.video = "Invalid video format. Only MP4, WebM, MOV, or OGG allowed.";
                    //     }
                    //     const fileSizeMB = values.video.size / (1024 * 1024);
                    //     if (fileSizeMB > MAX_VIDEO_SIZE_MB) {
                    //         error.video = `Video size should not exceed ${MAX_VIDEO_SIZE_MB}MB.`;
                    //     }
                    // }
                    // if (!values.video_length || !values.video_length.trim()) {
                    //     error.video_length = "Please select a video length.";
                    // }
                    if (!values.video_length && !values.video_length.trim()) {
                        error.video_length = "Please select a video length.";
                    } else if (values.video_length === "short" && values.video_type === "link") {
                        // Validate for YouTube Shorts
                        const shortError = validateYouTubeUrl(values.video_link, "short");
                        if (shortError) {
                            error.video_link = shortError;
                        }
                    } else if (values.video_length === "long" && values.video_type === "link") {
                        // Validate for YouTube regular video
                        const longError = validateYouTubeUrl(values.video_link, "long");
                        if (longError) {
                            error.video_link = longError;
                        }
                    }
                    if (!values.video_type || !values.video_type.trim()) {
                        error.video_type = "Please select a video type.";
                    }

                    if (values.video_type === "file") {
                        if (!values.video) {
                            error.video = "Please upload a video file.";
                        } else {
                            const isFile = values.video instanceof File || values.video instanceof Blob;
                            if (isFile) {
                                if (!allowedTypes.includes(values.video.type)) {
                                    error.video = "Invalid video format. Only MP4, WebM, MOV, or OGG allowed.";
                                }

                                const fileSizeMB = values.video.size / (1024 * 1024);
                                if (fileSizeMB > MAX_VIDEO_SIZE_MB) {
                                    error.video = `Video size should not exceed ${MAX_VIDEO_SIZE_MB}MB.`;
                                }
                            }
                        }
                    } else if (values.video_type === "link") {
                        if (!values.video_link || !values.video_link.trim()) {
                            error.video_link = "Please enter a video link.";
                        } 
                        // else {
                        //     const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
                        //     if (!urlPattern.test(values.video_link)) {
                        //         error.video_link = "Please enter a valid video link.";
                        //     }
                        // }
                    } 

                    return error;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    setSubmitted(true);
                    globalLoader(true);
                    console.log(values);
                    let formData = new FormData();
                    formData.append("center_id", params.center_id);
                    formData.append("title", values.title);
                    formData.append("description", values.description);
                    // formData.append("category", values.category);
                    formData.append("video_length", values.video_length);
                    formData.append("video_type", values.video_type);
                    if(values.video_type === "file" && values.video){
                        formData.append("video", values.video || "");
                    } else if(values.video_type === "link" && values.video_link){
                        formData.append("video_link", values.video_link || "");
                    }
                    if (values.thumbnail_image) {
                        formData.append("thumbnail_image", values.thumbnail_image);
                    }
                    AddEducationalVideo(formData)
                        .then((response) => {
                            setSubmitting(false);
                            if (response.success) {
                                Swal.fire({
                                    icon: "success",
                                    text: response.message,
                                    ...SWAL_SETTINGS,
                                });
                                setTimeout(() => {
                                    resetForm({ values: "" });
                                    globalLoader(false);
                                    navigate(`/admin/center-management/center/educational-video/${params.center_id}/list/1`);
                                }, 1000);
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    text: handleServerValidations(response),
                                    ...SWAL_SETTINGS,
                                });
                                setSubmitted(false);
                                globalLoader(false);
                            }
                        })
                        .catch((error) => {
                            console.log("error ====> ", error);
                        });
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setFieldTouched,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row row-sm">
                            <div className="col-lg-12 col-md-12 animation_fade">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <div>
                                            <h6 className="main-content-label mb-3">{t("Add Video")}</h6>
                                        </div>
                                        <div className="row row-sm">

                                            <div className="col-lg-6 text-center form-group">
                                                <label htmlFor="title" className="text-left d-flex">
                                                    {t("admin.faq.list_heading_title")}:<span className="requirestar">*</span>
                                                </label>
                                                <input
                                                    name="title"
                                                    id="title"
                                                    type="text"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.title}
                                                    className="form-control"
                                                    placeholder={t("Enter title")}
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.title && touched.title && t(errors.title)}
                                                </span>
                                            </div>
                                            {/* <div className="col-md-6 text-center form-group">
                                                <label className="text-left d-flex">
                                                    {t("Category")}
                                                    <span className="requirestar">*</span>
                                                </label>
                                                <select className="form-control form-select cp" name='category' value={values?.category} onChange={handleChange}>
                                                    <option value={""}>{t("Select")}</option>
                                                    {categories?.map((item, index) => { return (<option key={item?._id} value={item?.category}>{capitalizeFirstLetter(item?.category)}</option>) })}
                                                </select>
                                                <span className="text-danger d-flex text-left">
                                                    {errors.category && touched.category && t(errors.category)}
                                                </span>
                                            </div> */}
                                            <div className="col-lg-12 text-center form-group">
                                                <label htmlFor="description" className="text-left d-flex">
                                                    {t("admin.faq.label_description")}:<span className="requirestar">*</span>
                                                </label>
                                                <CustomCkeditor
                                                    fieldname={"description"}
                                                    setFieldValue={setFieldValue}
                                                    value={values.description}
                                                    setFieldTouched={setFieldTouched}
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.description &&
                                                        touched.description &&
                                                        t(errors.description)}
                                                </span>
                                            </div>
                                            <div className="col-lg-6 text-center form-group">
                                                <label htmlFor="thumbnail_image" className="text-left d-flex">
                                                    Upload Thumbnail Image:
                                                </label>
                                                <input
                                                    className="form-control imgInput"
                                                    id="thumbnail_image"
                                                    name="thumbnail_image"
                                                    accept="image/*"
                                                    type="file"
                                                    onChange={(event) => {
                                                        setFieldValue(
                                                            "thumbnail_image",
                                                            event.target.files[0] || ""
                                                        );
                                                        event.target.files.length === 1
                                                            ? setPreviewImage(
                                                                URL.createObjectURL(event.target.files[0])
                                                            )
                                                            : setPreviewImage("");
                                                    }}
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.thumbnail_image &&
                                                        touched.thumbnail_image &&
                                                        t(errors.thumbnail_image)}
                                                </span>
                                                {previewimage ? (
                                                    <ul className="question-image-preview questions-ul">
                                                        <li className="pr_img_box">
                                                            <img
                                                                src={previewimage}
                                                                style={{ height: "100px" }}
                                                                alt={"Profile_Img"}
                                                            />
                                                            <div className="img_options">
                                                                <button type="button" className="text-danger"
                                                                    onClick={() => {
                                                                        // console.log(previewResImage , previewimage)
                                                                        setPreviewImage("");
                                                                        setFieldValue("thumbnail_image", null);
                                                                        document.getElementById("thumbnail_image").value = ""
                                                                    }}>
                                                                    <i className="ri-delete-bin-6-fill"></i>
                                                                </button>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                            {/* <div className="col-lg-12 text-center form-group">
                                                <label htmlFor="video" className="text-left d-flex">
                                                    {t("Upload Video")}:<span className="requirestar">*</span>
                                                    <Whisper
                                                        placement="top"
                                                        controlId="control-id-hover"
                                                        trigger="hover"
                                                        speaker={
                                                            <Tooltip>
                                                                Maximum video upload size 100MB
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span className="field-more-info mt-1 ms-1 cp">
                                                            ?
                                                        </span>
                                                    </Whisper>
                                                </label>
                                                <input
                                                    type="file"
                                                    name="video"
                                                    id="video"
                                                    accept="video/*"
                                                    className="form-control"
                                                    onChange={(event) => {
                                                        setFieldValue("video", event.currentTarget.files[0]);
                                                    }}
                                                />
                                                <span className="text-danger d-flex text-left">
                                                    {errors.video &&
                                                        touched.video &&
                                                        t(errors.video)}
                                                </span>
                                            </div> */}

                                            <div className="col-lg-6 text-center form-group">
                                                <label htmlFor="video_length" className="text-left d-flex">
                                                    Select Video Length:<span className="requirestar">*</span>
                                                </label>
                                                <select
                                                    name="video_length"
                                                    id="video_length"
                                                    className="form-control"
                                                    onChange={(e) => {
                                                        const selectedType = e.target.value;
                                                        setFieldValue("video_length", selectedType);
                                                        if(selectedType === "short"){
                                                            setFieldValue("video_type", "link");
                                                            setFieldValue("video", "");
                                                        }
                                                    }}
                                                    value={values.video_length}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="short">Short Video</option>
                                                    <option value="long">Long Video</option>
                                                </select>
                                                <span className="text-danger d-flex text-left">
                                                    {errors.video_length && touched.video_length && t(errors.video_length)}
                                                </span>
                                            </div>

                                            <div className="col-lg-6 text-center form-group">
                                                <label htmlFor="video_type" className="text-left d-flex">
                                                    Select Video Type:<span className="requirestar">*</span>
                                                </label>
                                                <select
                                                    name="video_type"
                                                    id="video_type"
                                                    className="form-control"
                                                    onChange={(e) => {
                                                        const selectedType = e.target.value;
                                                        setFieldValue("video_type", selectedType);
                                                        // Clear the other field when switching
                                                        if (selectedType === "file") {
                                                            setFieldValue("video_link", "");
                                                            setFieldValue("video", "");
                                                        } else {
                                                            setFieldValue("video", "");
                                                            setFieldValue("video_link", "");
                                                        }
                                                    }}
                                                    value={values.video_type}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="file">Upload Video Manually</option>
                                                    <option value="link"> YouTube Link</option>
                                                </select>
                                                <span className="text-danger d-flex text-left">
                                                    {errors.video_type && touched.video_type && t(errors.video_type)}
                                                </span>
                                            </div>


                                            {values.video_type === "file" && (
                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="video" className="text-left d-flex">
                                                        {t("Upload Video")}:<span className="requirestar">*</span>
                                                        <Whisper
                                                            placement="top"
                                                            controlId="control-id-hover"
                                                            trigger="hover"
                                                            speaker={
                                                                <Tooltip>Maximum video upload size 15MB</Tooltip>
                                                            }
                                                        >
                                                            <span className="field-more-info mt-1 ms-1 cp">?</span>
                                                        </Whisper>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        name="video"
                                                        id="video"
                                                        accept="video/*"
                                                        className="form-control"
                                                        onChange={(event) => {
                                                            setFieldValue("video", event.currentTarget.files[0]);
                                                        }}
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.video && touched.video && t(errors.video)}
                                                    </span>

                                                    {/* {showVideoData && (
                                                        <ul className="question-image-preview questions-ul">
                                                            <li className="pr_img_box">
                                                                <video
                                                                    src={showVideoData}
                                                                    style={{ height: "100px" }}
                                                                    controls
                                                                />
                                                            </li>
                                                        </ul>
                                                    )} */}
                                                </div>
                                            )}


                                            {values.video_type === "link" && (
                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="video_link" className="text-left d-flex">
                                                        Upload Video Link:<span className="requirestar">*</span>
                                                    </label>
                                                    <input
                                                        name="video_link"
                                                        id="video_link"
                                                        type="text"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.video_link}
                                                        className="form-control"
                                                        placeholder="Enter video link"
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.video_link && touched.video_link && t(errors.video_link)}
                                                    </span>
                                                </div>
                                            )}

                                            <div className="">
                                                <button
                                                    className="btn btn-main-primary signbtn mr-2"
                                                    type="submit"
                                                    disabled={submitted ? true : null}
                                                >
                                                    <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                    {t("admin.button.btn_submit")}
                                                </button>
                                                <button
                                                    className="btn ripple btn-secondary"
                                                    type="button"
                                                    disabled={submitted ? true : null}
                                                    onClick={() => navigate(-1)}
                                                >
                                                    <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                    {t("admin.button.btn_cancel")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
            {/* ) : (
                <></>
            )} */}
        </>
    );
};

export default EducationalVideoAdd;
